import { createBrowserHistory } from "history";
let History = createBrowserHistory();
export default History;
